module.exports = "https://cdn.realtymogul.com/static/media/multifamily_chart.0b738667.png";